import { Routes } from '@angular/router';
import { MainLayoutComponent } from './main-layout.component';
import { AuthGuard } from '../auth/guards/auth.guard';
import { LibraryThemeGuard } from 'src/app/shared/services/library-theme.guard';
import { AuthorizationGuard } from '../auth/guards/authorization.guard';
import { PermissionsList } from 'src/app/shared/common/PermissionList';
import { googlemapsInitializerResolver } from 'src/app/shared/services/googlemaps-initializer.resolver';

export const mainRoutes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('../../features/dashboard/dashboard.routes').then(
            m => m.DashboardRoutes,
          ),
      },
      {
        path: 'rides',
        loadChildren: () =>
          import('../../features/rides/rides.routes').then(m => m.ridesRoutes),
      },
      {
        path: 'accounting',
        loadChildren: () =>
          import('../../features/accounting/accounting.routes').then(
            m => m.accountingRoutes,
          ),
      },
      {
        path: 'routing',
        loadChildren: () =>
          import('../../features/routing/routing.routes').then(
            m => m.routingRoutes,
          ),
      },
      {
        path: 'drivers',
        loadChildren: () =>
          import('../../features/drivers/drivers.routes').then(
            m => m.driversRoutes,
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('../../features/reports/reports.routes').then(
            m => m.reportsRoutes,
          ),
      },
      {
        path: 'vehicles-equipment',
        loadChildren: () =>
          import(
            '../../features/vehiclesAndEquipment/vehicleAndEquipment.routes'
          ).then(m => m.vehicleAndEquipmentRoutes),
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },

      {
        path: 'dispatch',
        loadChildren: () =>
          import('@gozetta/dispatch-portal').then(m => m.routes),
        canActivate: [LibraryThemeGuard, AuthorizationGuard],
        canDeactivate: [LibraryThemeGuard],
        title: 'Active Rides | ADROIT',
        data: {
          PermissionPageName: [
            PermissionsList[PermissionsList.ServiceProviderActiveRidesView],
          ],
        },
      },
    ],
    canActivate: [AuthGuard],
    resolve: {
      googleMapsInitialized: googlemapsInitializerResolver,
    },
    title: 'main-layout',
  },
];
